/* Penrose FAQ accordion: smooth height animation on native <details>. */
(function () {
  if (window.__pnFaqBound) return;
  window.__pnFaqBound = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DUR = 280;
  var EASE = 'cubic-bezier(.4,0,.2,1)';

  function animate(el, from, to, done) {
    if (el._pnAnim) el._pnAnim.cancel();
    if (reduce || !el.animate) { done && done(); return; }
    var a = el.animate([{ height: from + 'px', opacity: from ? 1 : 0 }, { height: to + 'px', opacity: to ? 1 : 0 }], { duration: DUR, easing: EASE });
    el._pnAnim = a;
    a.onfinish = function () { el._pnAnim = null; done && done(); };
    a.oncancel = function () { el._pnAnim = null; };
  }

  function openItem(d) {
    var body = d.querySelector('.pn-faq__a');
    d.classList.remove('is-closing');
    d.open = true;
    animate(body, 0, body.scrollHeight);
  }

  function closeItem(d) {
    var body = d.querySelector('.pn-faq__a');
    d.classList.add('is-closing');
    animate(body, body.offsetHeight, 0, function () {
      d.open = false;
      d.classList.remove('is-closing');
    });
  }

  document.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('.pn-faq__q');
    if (!sum) return;
    var d = sum.parentElement;
    if (!d || d.tagName !== 'DETAILS') return;
    e.preventDefault();
    if (d.open && !d.classList.contains('is-closing')) {
      closeItem(d);
    } else {
      var list = d.closest('[data-pn-faq]');
      if (list && list.getAttribute('data-single') === 'true') {
        list.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) closeItem(o); });
      }
      openItem(d);
    }
  });
})();
